import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    standalone: false,
  selector: '[appTimeFormat]'
})
export class TimeFormatDirective {

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    // Remove any non-digit characters
    const cleanedValue = value.replace(/[^0-9:]/g, '');

    // Ensure the value is formatted as HH:MM
    if (/^\d{1,2}(:\d{0,2})?$/.test(cleanedValue)) {
      input.value = cleanedValue;
    } else {
      input.value = '';
    }
  }
}
